"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SkeletonWrapper = _interopRequireDefault(require("../SkeletonWrapper"));
var _OfferSwitchCardStyled = require("./OfferSwitchCardStyled");
var _jsxRuntime = require("react/jsx-runtime");
const OfferSwitchCardLoader = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_OfferSwitchCardStyled.WrapperStyled, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
      showChildren: false,
      width: 50,
      height: 50
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_OfferSwitchCardStyled.InnerWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
        showChildren: false,
        width: 200,
        margin: "0 10px 10px 10px"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
        showChildren: false,
        width: 300,
        margin: "0 10px 10px 10px"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferSwitchCardStyled.PriceWrapperStyled, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
        showChildren: false,
        width: 80,
        height: 30
      })
    })]
  });
};
var _default = exports.default = OfferSwitchCardLoader;